if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // Inicializar tu sección personalizada
        this.initCustomVariantSection();
      }

      initCustomVariantSection() {
        // Esperar a que el DOM esté completamente cargado
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            this.setupVariantSection();
          });
        } else {
          this.setupVariantSection();
        }
      }

      setupVariantSection() {
        // Buscar donde insertar la sección (similar a tu lógica original)
        let targetElement = document.querySelector('#ss-product-variants');
        
        if (!targetElement) {
          // Usar los mismos selectores que tienes en tu código original
          const selectors = [
            '.product__title',
            '.product__description', 
            '.price.price--large.price--show-badge',
            '.button--add-to-cart',
            '.product .product-form',
            '.product-single__add-to-cart',
            '.shopify-payment-button',
            '.shopify-payment-button__button',
            '.ProductForm__BuyButtons',
            '.add-to-cart'
          ];
          
          for (const selector of selectors) {
            targetElement = document.querySelector(selector);
            if (targetElement) break;
          }
        }

        if (!targetElement) return;

        // Buscar el template de tu sección
        const template = document.querySelector('[id^="ss-product-variants-template-"]');
        if (!template) return;

        // Insertar la sección
        this.insertVariantSection(targetElement, template);
        
        // Configurar event listeners
        this.setupVariantClickHandlers();
        
        // Inicializar slider si es necesario
        this.initSliderIfNeeded();
      }

      insertVariantSection(targetElement, template) {
        const templateContent = template.content || template.querySelector('div');
        const clonedContent = templateContent.cloneNode(true);
        
        // Insertar después del elemento target (como en tu código original)
        targetElement.insertAdjacentElement('afterend', clonedContent);
      }

      setupVariantClickHandlers() {
        const variantLinks = document.querySelectorAll('[class*="variants-item-"]');
        
        variantLinks.forEach(link => {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleVariantSelection(link);
          });
        });
      }

      handleVariantSelection(selectedLink) {
        // Remover clase active de todos los elementos
        const allVariantItems = document.querySelectorAll('[class*="variants-item-"]');
        allVariantItems.forEach(item => item.classList.remove('active'));
        
        // Agregar clase active al seleccionado
        selectedLink.classList.add('active');
        
        // Extraer el ID de la variante de la URL
        const url = selectedLink.getAttribute('href');
        if (url && url.includes('variant=')) {
          const urlParams = new URLSearchParams(url.split('?')[1]);
          const variantId = urlParams.get('variant');
          
          if (variantId && this.variantIdInput) {
            // Actualizar el input hidden con el ID de la variante
            this.variantIdInput.value = variantId;
            
            // Disparar evento de cambio de variante
            this.variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
            
            // Actualizar la URL sin recargar la página
            const newUrl = new URL(window.location);
            newUrl.searchParams.set('variant', variantId);
            window.history.replaceState({}, '', newUrl);
          }
        }
      }

      initSliderIfNeeded() {
        const sliderElement = document.querySelector('[class*="variants-slider-"]');
        if (!sliderElement) return;

        // Cargar Swiper si no está cargado
        if (typeof Swiper === 'undefined') {
          this.loadSwiper().then(() => {
            this.initSwiper(sliderElement);
          });
        } else {
          this.initSwiper(sliderElement);
        }
      }

      loadSwiper() {
        return new Promise((resolve) => {
          if (document.querySelector('script[src*="swiper-bundle"]')) {
            resolve();
            return;
          }

          const script = document.createElement('script');
          script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
          script.onload = resolve;
          document.head.appendChild(script);
        });
      }

      initSwiper(sliderElement) {
        setTimeout(() => {
          sliderElement.classList.remove("preview");
          
          // Extraer el ID de la sección del nombre de clase
          const className = sliderElement.className;
          const sectionIdMatch = className.match(/variants-slider-(\d+)/);
          const sectionId = sectionIdMatch ? sectionIdMatch[1] : '';

          const slider = new Swiper(sliderElement, {
            speed: 500,
            spaceBetween: 20,
            navigation: {
              prevEl: `.variants-btn-prev-${sectionId}`,
              nextEl: `.variants-btn-next-${sectionId}`,
            },
            breakpoints: {
              320: {
                spaceBetween: 10, // Puedes ajustar estos valores
                slidesPerView: 2
              },
              768: {
                spaceBetween: 15,
                slidesPerView: 3
              },
              1024: {
                spaceBetween: 20,
                slidesPerView: 4
              }
            }
          });

          // Prevenir reflow durante cambios de variante
          const variantSection = document.querySelector(`.section-${sectionId}`);
          if (variantSection) {
            variantSection.style.minHeight = variantSection.offsetHeight + 'px';
          }

        }, 400);
      }

      // Resto del código original del onSubmitHandler...
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
